import { DEFAULT_LABEL_BG_COLOR } from 'Src/constants'
import styles from './WidgetPreview.module.css'
import { useFormContext } from 'react-hook-form'
import { getColorForTheme } from '../utils'

const BadgeLogo = ({ brandImageUrl }) => {
  const { watch } = useFormContext()

  const textColor = getColorForTheme(watch('textColor'))
  const showBadgeLogo = watch('showBadgeLogo')

  if (showBadgeLogo) {
    return <img className={styles.BadgeLogo} src={brandImageUrl} />
  }

  return (
    <svg
      className={styles.SpeechBubble}
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='30'
      fill={textColor}
    >
      <path
        className='path'
        d='M21.067 0c7.732 0 14 6.268 14 14s-6.268 14-14 14h-7c-.517 0-1.026-.028-1.528-.082l-6.765 4.057a1 1 0 01-1.51-.957l.644-6.43A13.968 13.968 0 01.067 14c0-7.732 6.268-14 14-14h7z'
        fillRule='evenodd'
      />
    </svg>
  )
}

const MinimizedWidgetPreview = ({ brandImageUrl }) => {
  const { watch } = useFormContext()

  const brandColor = watch('brandColor')

  const badgeLabelText = watch('badgeLabel')
  const showBadgeLabel = watch('showBadgeLabel')
  const badgeLabelBgColor = watch('badgeLabelBgColor')
  const badgeLabelTextColor = getColorForTheme(watch('badgeLabelTextColor'))

  const canShowBadgeLabel = badgeLabelText.length > 3 && showBadgeLabel

  const badgeStyle = {
    backgroundColor: canShowBadgeLabel ? badgeLabelBgColor : DEFAULT_LABEL_BG_COLOR
  }

  const badgeLabelStyle = {
    ...badgeStyle,
    color: badgeLabelTextColor
  }

  const backDropStyle = { backgroundColor: brandColor }

  return (
    <div className={styles.MinimizedBadgeContainer}>
      <div style={badgeStyle} className={styles.Badge}>
        <span style={backDropStyle} className={styles.Backdrop} />
        <BadgeLogo brandImageUrl={brandImageUrl} />
      </div>
      {canShowBadgeLabel && (
        <div style={badgeLabelStyle} className={styles.BadgeLabel}>
          {badgeLabelText}
        </div>
      )}
    </div>
  )
}

export default MinimizedWidgetPreview
